// Formulaire de don (form GF #3) — funnel multi-step en JS par-dessus un form GF à une seule page.
// Option B : on ne crée jamais de saut de page GF, on regroupe les .gfield existants (repérés par
// leur id #field_3_{n}, cf. mapping ci-dessous) dans 3 panneaux, avec une progression + nav Précédent/
// Continuer. Le vrai bouton submit GF (.gform_footer) reste caché jusqu'à l'étape 3.

function pdwDonIsVisible(el) {
	return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
}

function pdwDonLabelFor(wrapper, input) {
	if (!input) {
		return '';
	}
	let label = input.id && wrapper.querySelector('label[for="' + input.id + '"]');
	if (!label) {
		const choice = input.closest('.gchoice') || input.parentElement;
		label = choice && choice.querySelector('label');
	}
	const text = label ? label.textContent.trim() : (input.value || '');
	return text.split('|')[0].trim(); // le champ produit encode "Label|Prix"
}

// Applique un préformatage "au fil de la saisie" sur un input : ne garde que les chiffres (max maxDigits)
// et les reformate via format(digits). Idempotent (dataset.pdwMask).
function pdwDonMask(input, placeholder, maxDigits, format) {
	if (!input || input.dataset.pdwMask) {
		return;
	}
	input.dataset.pdwMask = '1';
	input.setAttribute('inputmode', 'numeric');
	input.setAttribute('placeholder', placeholder);
	input.addEventListener('input', function () {
		this.value = format(this.value.replace(/\D/g, '').slice(0, maxDigits));
	});
}

window.initPdwDon = function () {
	const wrapper = document.getElementById('gform_wrapper_3');

	// Garde-fou : pas de form de don sur cette page → rien à faire.
	// Idempotence : on teste la présence du funnel déjà injecté (.pdw-don-steps), PAS une classe sur le
	// wrapper — GF remplace le <form> intérieur au re-render AJAX mais garde #gform_wrapper_3, donc une
	// classe sur le wrapper persisterait et empêcherait la reconstruction du funnel après une erreur.
	if (!wrapper || wrapper.querySelector('.pdw-don-steps')) {
		return;
	}

	// Mapping des champs GF réels (form #3) par étape — cf. spec.
	// 13 = champ Mollie (l'add-on l'exige pour créer un feed) : il doit vivre dans l'étape 3, sinon il
	// resterait hors des panneaux, donc visible à toutes les étapes. Un id absent du DOM est ignoré.
	const stepMap = { 1: [1, 5, 6, 7], 2: [2, 3, 4, 8, 9, 10, 11], 3: [12, 13] };
	const fieldEls = {};
	let anyField = null;

	Object.keys(stepMap).forEach((step) => {
		stepMap[step].forEach((id) => {
			const el = wrapper.querySelector('#field_3_' + id);
			if (el) {
				fieldEls[id] = el;
				anyField = anyField || el;
			}
		});
	});

	// Garde-fou : markup GF inattendu (aucun champ mappé trouvé) → on ne casse rien.
	if (!anyField) {
		return;
	}

	const container = anyField.parentNode;
	const footer = wrapper.querySelector('.gform_footer');

	// 1) On insère d'abord les marqueurs (progression + 3 panneaux + nav) en se calant sur la position
	//    du premier champ, AVANT de déplacer le moindre champ : ça garde une référence DOM stable
	//    (insertBefore exige que le nœud de référence soit toujours un enfant du parent).
	const stepsBar = document.createElement('div');
	stepsBar.className = 'pdw-don-steps';
	stepsBar.innerHTML =
		'<div class="pdw-don-step-labels">' +
		['Votre don', 'Vos coordonnées', 'Finalisation'].map((label, i) =>
			'<div class="pdw-don-step-label" data-pdw-dot="' + (i + 1) + '">' +
			'<span class="pdw-don-dot">' + (i + 1) + '</span>' + label +
			'</div>'
		).join('') +
		'</div>' +
		'<div class="pdw-don-bar"><span></span></div>';
	container.insertBefore(stepsBar, anyField);

	const panels = {};
	[1, 2, 3].forEach((step) => {
		const panel = document.createElement('div');
		panel.className = 'pdw-don-step-panel';
		panel.setAttribute('data-pdw-step', String(step));
		container.insertBefore(panel, anyField);
		panels[step] = panel;
	});

	const nav = document.createElement('div');
	nav.className = 'pdw-don-nav';
	nav.innerHTML =
		'<button type="button" class="pdw-don-btn-ghost" data-pdw-prev hidden>Précédent</button>' +
		'<span class="pdw-don-nav-spacer"></span>' +
		'<button type="button" class="pdw-don-btn-next" data-pdw-next>Continuer</button>';
	container.insertBefore(nav, anyField);

	// Le submit GF vit dans son propre bloc .gform_footer, donc sous la nav : à l'étape 3 il s'empilait
	// sous « Précédent » au lieu d'être à droite comme l'était « Continuer ». On le déplace DANS la nav
	// (il reste dans le <form>, donc la soumission GF n'est pas affectée) ; goToStep continue de piloter
	// sa visibilité via footer.style.display.
	if (footer) {
		nav.appendChild(footer);
	}

	// 2) Seulement maintenant on déplace les vrais champs GF dans leurs panneaux respectifs.
	[1, 2, 3].forEach((step) => {
		stepMap[step].forEach((id) => {
			if (fieldEls[id]) {
				panels[step].appendChild(fieldEls[id]);
			}
		});
	});

	const prevBtn = nav.querySelector('[data-pdw-prev]');
	const nextBtn = nav.querySelector('[data-pdw-next]');
	const dots = stepsBar.querySelectorAll('[data-pdw-dot]');
	const barFill = stepsBar.querySelector('.pdw-don-bar > span');

	function firstMissingRequired(panel) {
		let missing = null;
		panel.querySelectorAll('.gfield').forEach((field) => {
			if (!pdwDonIsVisible(field) || !field.querySelector('.gfield_required')) {
				field.classList.remove('pdw-don-field-missing');
				return;
			}
			const radios = field.querySelectorAll('input[type="radio"]');
			const checks = field.querySelectorAll('input[type="checkbox"]');
			let ok;
			if (radios.length) {
				ok = Array.prototype.some.call(radios, (r) => r.checked);
			} else if (checks.length) {
				ok = Array.prototype.some.call(checks, (c) => c.checked);
			} else {
				const input = field.querySelector('input, select, textarea');
				ok = !!(input && input.value.trim() !== '');
			}
			field.classList.toggle('pdw-don-field-missing', !ok);
			if (!ok && !missing) {
				missing = field;
			}
		});
		return missing;
	}

	function buildRecap() {
		let recap = panels[3].querySelector('.pdw-don-recap');
		if (!recap) {
			recap = document.createElement('div');
			recap.className = 'pdw-don-recap';
			panels[3].insertBefore(recap, panels[3].firstChild);
		}
		recap.textContent = '';
		const amount = pdwDonLabelFor(wrapper, wrapper.querySelector('#field_3_1 input[type="radio"]:checked'));
		const donorType = pdwDonLabelFor(wrapper, wrapper.querySelector('#field_3_5 input[type="radio"]:checked'));
		[
			['Montant du don', amount || '—'],
			['Vous donnez en tant que', donorType || '—']
		].forEach(([label, value]) => {
			const row = document.createElement('div');
			row.className = 'pdw-don-recap-line';
			const span = document.createElement('span');
			span.textContent = label;
			const strong = document.createElement('strong');
			strong.textContent = value;
			row.appendChild(span);
			row.appendChild(strong);
			recap.appendChild(row);
		});
	}

	let current = 1;

	function goToStep(step) {
		current = step;
		[1, 2, 3].forEach((s) => {
			panels[s].classList.toggle('pdw-don-step-active', s === step);
		});
		dots.forEach((dot) => {
			const s = Number(dot.getAttribute('data-pdw-dot'));
			dot.classList.toggle('is-active', s === step);
			dot.classList.toggle('is-done', s < step);
		});
		if (barFill) {
			barFill.style.transform = 'scaleX(' + (step / 3) + ')';
		}
		prevBtn.hidden = step === 1;
		nextBtn.hidden = step === 3;
		if (footer) {
			footer.style.display = step === 3 ? '' : 'none';
		}
		if (step === 3) {
			buildRecap();
		}
	}

	nextBtn.addEventListener('click', () => {
		const missing = firstMissingRequired(panels[current]);
		if (missing) {
			missing.scrollIntoView({ behavior: 'smooth', block: 'center' });
			return;
		}
		if (current < 3) {
			goToStep(current + 1);
		}
	});

	prevBtn.addEventListener('click', () => {
		if (current > 1) {
			goToStep(current - 1);
		}
	});

	// Préformatage n° Registre national belge (YY.MM.DD-XXX.CC, 11 chiffres).
	pdwDonMask(wrapper.querySelector('#field_3_6 input[type="text"]'), 'YY.MM.DD-XXX.CC', 11, function (d) {
		let out = d.slice(0, 2);
		if (d.length > 2) { out += '.' + d.slice(2, 4); }
		if (d.length > 4) { out += '.' + d.slice(4, 6); }
		if (d.length > 6) { out += '-' + d.slice(6, 9); }
		if (d.length > 9) { out += '.' + d.slice(9, 11); }
		return out;
	});

	// Préformatage n° d'entreprise (BCE) belge (XXXX.XXX.XXX, 10 chiffres).
	pdwDonMask(wrapper.querySelector('#field_3_7 input[type="text"]'), 'XXXX.XXX.XXX', 10, function (d) {
		let out = d.slice(0, 4);
		if (d.length > 4) { out += '.' + d.slice(4, 7); }
		if (d.length > 7) { out += '.' + d.slice(7, 10); }
		return out;
	});

	// Si GF revalide en AJAX et renvoie une erreur serveur (.gfield_error), on ouvre directement
	// l'étape concernée plutôt que de laisser l'erreur cachée derrière un panneau masqué.
	const errorField = wrapper.querySelector('.gfield_error');
	let startStep = 1;
	if (errorField) {
		Object.keys(stepMap).some((step) => {
			if (stepMap[step].some((id) => fieldEls[id] === errorField)) {
				startStep = Number(step);
				return true;
			}
			return false;
		});
	}
	goToStep(startStep);
};

document.addEventListener('DOMContentLoaded', function () {
	window.initPdwDon();

	// Barba déclenche déjà gform_post_render en afterEnter (cf. pdw_barba.js) : on s'y accroche pour
	// réinitialiser le funnel après une navigation AJAX ou une re-validation GF.
	if (window.jQuery) {
		window.jQuery(document).on('gform_post_render', function (event, formId) {
			if (Number(formId) === 3) {
				window.initPdwDon();
			}
		});
	}
});
